import Box from '@common/components/Box';
import Container from '@common/components/Container';
import Button from '@common/components/controls/Button';
import Icon from '@common/components/Icon';
import ErrorIcon from '@common/components/svgs/common/Error';
import Translated from '@common/components/Translated';
import '@common/styles/components/error.pcss';

export interface ErrorProps {
  code: number;
  action?: () => void;
}

function ErrorPage({ code, action }: Readonly<ErrorProps>) {
  const errorMessageCode = code.toString().startsWith('5')
    ? 500
    : code;

  return (
    <Container className="error">
      <Icon component={ErrorIcon} />
      <Translated id="common.errors.code.title" values={{ code }} tagName="h1" />
      <Translated id={`common.errors.code-${errorMessageCode}`} tagName="p" />
      {errorMessageCode === 404 && !!action && (
        <Box mt={8}>
          <Button mode="secondary" onClick={action} data-testid="home-button" disableAutoCapture>
            <Translated id="common.errors.action.home" />
          </Button>
        </Box>
      )}
    </Container>
  );
}

export default ErrorPage;
